module.exports = __webpack_public_path__ + "static/img/8.74e713c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/zh/8.png
// module id = zU16
// module chunks = 0